import { Injectable } from '@angular/core';

import { ClientConfig, ClientConfigProductName, ClientConfigService } from '@frontend/vanilla/core';

@ClientConfig({
    key: 'bmaEnvironmentConfig',
    product: ClientConfigProductName.OZONE,
    reload: false,
})
@Injectable({
    providedIn: 'root',
    deps: [ClientConfigService],
    useFactory: bmaConfigFactory,
})
export class EnvironmentConfig {
    configuration: IConfiguration;
    cmsConfig: string;
}

export function bmaConfigFactory(service: ClientConfigService) {
    return service.get(EnvironmentConfig);
}

export interface IConfiguration {
    BRAND?: string;
    VERSION?: string;
    PRODUCTION?: boolean;
    ENVIRONMENT?: string;
    CURRENT_PLATFORM?: string;
    DOMAIN?: string;
    GOOGLETAGMANAGERID?: string[];
    ALLOWED_HR_LUCKYDIP_CATEGORY_IDS?: string[];
    BETRADAR_WIDGETLOADERURL?: string;
    IMG_ARENA_SCOREBOARD?: string;
    IMG_ARENA_OPERATOR_ID?: string;
    IMG_ARENA_OPERATOR_SECRET_KEY?: string;
    EVENT_CATEGORIES_WITH_WATCH_RULES?: string[];
    BPP_ENDPOINT?: string;
    BETTINGMS?: string;
    SITESERVER_BASE_URL?: string;
    SITESERVER_VERSION?: string;
    SITESERVER_DNS?: string;
    SITESERVER_ENDPOINT?: string;
    SITESERVER_COMMON_ENDPOINT?: string;
    SITESERVER_LOTTERY_ENDPOINT?: string;
    SITESERVER_HISTORIC_ENDPOINT?: string;
    SITESERVER_COMMENTARY_ENDPOINT?: string;
    IMAGES_RACE_ENDPOINT?: string;
    IMAGES_ENDPOINT?: string;
    INT_TOTE_IMAGES_ENDPOINT?: string;
    SURFACE_BETS_URL?: string;
    PRICE_BOOST_URL?: string;
    REACTION_SB?: string;
    SHOWDOWN_MS?: string;
    CMS_ENDPOINT?: string;
    CMS_ROOT_URI?: string;
    CMS_LINK?: string;
    PERFORM_GROUP_END_POINT?: string;
    PERFORM_GROUP_END_POINT_DESKTOP?: string;
    IMG_END_POINT?: string;
    QUANTUMLEAP_SCRIPT_ENDPOINT?: string;
    VISUALIZATION_ENDPOINT?: string;
    VISUALIZATION_TENNIS_ENDPOINT?: string;
    QUANTUMLEAP_BOOKMAKER?: string;
    VISUALIZATION_IFRAME_URL?: string;
    VISUALIZATION_PREMATCH_URL?: string;
    DIGITAL_SPORTS_IFRAME_URL?: string;
    DIGITAL_SPORTS_SYSTEM_ID?: number;
    STATS_CENTRE_ENDPOINT?: string;
    OPT_IN_ENDPOINT?: string;
    ONE_TWO_FREE_ENDPOINT?: string;
    IG_MEDIA_TOTE_ENDPOINT?: string;
    IG_MEDIA_ENDPOINT?: string;
    IGM_STREAM_SERVICE_ENDPOINT?: string;
    APOLLO?: ApolloModel;
    BET_FINDER_ENDPOINT?: string;
    BET_FILTER_ENDPOINT?: string;
    BET_TRACKER_ENDPOINT?: string;
    PRE_CREATED_ENDPOINT?: string;
    SHOP_LOCATOR_ENDPOINT?: string;
    NOTIFICATION_CENTER_ENDPOINT?: string;
    LIVESERV?: LSModel;
    BR_TYPE_ID?: string[];
    CATEGORIES_DATA?: SportsConfigModel;
    LOTTERIES_CONFIG?: object;
    TOTE_CLASSES?: object;

    OPTA_SCOREBOARD?: OPTAScoreboardModel;
    COUPON_STATS_EXTERNAL_URL?: string;
    INPLAY_STATS_EXTERNAL_URL?: string;
    FIVEASIDE?: FiveASideModel;
    MOBILEWIDTH?: number;
    LANDTABLETWIDTH?: number;
    DESKTOPWIDTH?: number;
    FEATURED_SPORTS?: string;
    INPLAYMS?: string;
    POPULARBETS_MS?: string;
    LIVESERVEMS?: string;
    REMOTEBETSLIPMS?: string;
    EDPMS?: string;
    BIG_COMPETITION_MS?: string;
    UPMS?: string;
    UPMS_ROOT_API?: string;
    BET_GENIUS_SCOREBOARD?: BGModel;
    HELP_SUPPORT_URL?: string;
    HELP_LOTTO_RULES?: string;
    TIME_ENDPOINT?: string;
    TIMEFORM_ENDPOINT?: string;
    FREE_RIDE_PLACEBET_ENDPOINT?: string;
    ONE_TWO_FREE_API_ENDPOINT?: string;
    PROMO_LB_ENDPOINT?: string;
    RACING_POST_API_ENDPOINT?: string;
    RACING_POST_ONE_API_ENDPOINT?: string;
    RACING_POST_API_KEY?: string;
    GAMING_URL?: string[];
    VS_QUOLITY_MAP?: VSQualityModel;
    BYB_CONFIG?: BYBConfigModel;
    HORSE_RACING_CATEGORY_ID?: string;
    UPCELL_ENDPOINT?: string;
    TOTE_CATEGORY_ID?: string;
    RULE_FOUR_URL?: string;
    EXTERNAL_URL?: object;
    CASHOUT_MS?: string;
    VIP_USERS_EXTERNAL_URL?: string;
    DESKTOP_VIP_USERS_EXTERNAL_URL?: string;
    MINI_GAMES_IFRAME_URL?: string;
    STORAGE_SERVICE_PREFIX?: string;
    RPG_API_CONFIG?: RPGModel;
    QUESTION_ENGINE_ENDPOINT?: string;
    IDENTITY_ID?: string;
    TIMELINE_MS?: string;
    HOME_PAGE?: string;
    OXYMS?: string;
    CMS_ASSETS?: string;
    GOOGLE_RECAPTCHA?: GoogleRecaptchaModel;
    ISEVENTCOALESCING?: boolean;
    FLAG_CLIENT_KEY?: string;
    TRENDING_BETS_API_ENDPOINT?: string;
    CSB_PLAYER?: string;
    CRC_HORSES_API_ENDPOINT?: string;
    CRC_SC_KEY?: string;
    SCOREBOARD_MFE?: ScoreboardModel;
    INPLAYMS_ENDPOINT?: string;
    FANZONE_PREMIER_LEAGUE_API_KEY?: string;
    ATR_END_POINT?: string;
    OB_LIVESERV?: OBLiveservModel;
    DIGITAL_COUPONS_ENDPOINT?: string;
    LIVE_COMMENTARY_URL?: string;
    IS_DYNAMIC?: boolean;
    brand?: string;
    COMMUNICATION_URL?: string;
    BANNERS_CONFIG?: BannersConfigModel;
}

export interface OBLiveservModel {
    WS_URL?: string;
    PROTOCOL_URL?: string;
}

export interface BYBConfigModel {
    URI?: string;
    HR_YC_EVENT_TYPE_ID?: number;
}

export interface OPTAScoreboardModel {
    CDN?: string;
    ENV?: string;
}

export interface ScoreboardModel {
    URI?: string;
    ENV?: string;
}

export interface ApolloModel {
    API_ENDPOINT?: string;
    CWA_ROUTE?: string;
    UCMS_ROUTE?: string;
    CARD_ENDPOINT?: string;
    API_KEY?: string;
}

export interface LSModel {
    DOMAIN?: string;
    PUSH_COMMON_SUBDOMAIN?: string;
    PUSH_LOCATION_HANDLER?: string;
    PUSH_URL?: string;
    PUSH_INSTANCE_URL?: string;
    PUSH_INSTANCE_PORT?: string;
    PUSH_INSTANCE_TYPE?: string;
    PUSH_IFRAME_ID?: string;
    PUSH_VERSION?: string;
}

export interface FiveASideModel {
    CONTESTPATH?: string;
    SVGIMAGEPATH?: string;
    ENTRYCONFIRMATIONPATH?: string;
    FIVEASIDEBETSPATH?: string;
}

export interface BGModel {
    SCORECENTRE?: string;
    API?: string;
}

export interface VSQualityModel {
    DESKTOP?: string;
    TABLET?: string;
    MOBILE?: string;
}

export interface RPGModel {
    GAMES_URL?: string;
    FETCH_URL?: string;
    XBC_LOADER?: XBCLoaderModel;
}

export interface XBCLoaderModel {
    DATA_BUNDLE?: string;
    SRC?: string;
}

export interface GoogleRecaptchaModel {
    URI?: string;
    ACCESS_TOKEN?: string;
}

export interface ToteModel {
    GREYHOUNDS?: number;
    HORSERACING?: number;
    TROTTING?: number;
}

export interface LotteryModel {
    COUNTRY?: string;
    COLOR?: string;
    INCONNECT?: boolean;
    EXCLUDED?: boolean;
    LIMITS?: number;
}

export interface BannersConfigModel {
    SIZES_DESKTOP_BACKGROUND?: string;
    SIZES_DESKTOP_FOREGROUND?: string;
    SIZES_MOBILE_BACKGROUND?: string;
    SIZES_MOBILE_FOREGROUND?: string;
    SRCSET_MOBILE?: string[];
    SRCSET_DESKTOP?: string[];
}

export interface RacingDataModel {
    name?: string;
    path?: string;
    id?: string;
    specialsClassIds?: string;
}
export interface RacingModel {
    horseracing?: RacingDataModel;
    greyhound?: RacingDataModel;
    virtualMotorsports?: RacingDataModel;
    virtualCycling?: RacingDataModel;
    virtualHorseRacing?: RacingDataModel;
    virtualGreyhound?: RacingDataModel;
}

export interface FBCouponsModel {
    idsToIntersect?: Array<number>;
    typeIds?: string;
}
export interface DefMarketsModel {
    sportIds?: Array<string>;
    name?: string;
}

export interface SportsConfigModel {
    racing?: { [key: string]: RacingDataModel };
    virtuals?: Array<RacingDataModel>;
    currentMatches: Array<RacingDataModel>;
    footballCoupons?: FBCouponsModel;
    footballId?: string;
    categoryIds: Array<string>;
    tierOne: Array<string>;
    unhandledSportsForMTA: Array<string>;
    sortCodesForMTA: Array<string>;
    golfSport: string;
    golfId: string;
    currentSetMarketNames: Array<string>;
    defaultMarkets: Array<DefMarketsModel>;
    specialMarkets: Array<string>;
    specialTagCode: string;
}
